@file:OptIn(
  org.jetbrains.compose.resources.InternalResourceApi::class,
  org.jetbrains.compose.resources.ExperimentalResourceApi::class,
)

package orbitals.appcompose.generated.resources

import kotlin.ByteArray
import kotlin.OptIn
import kotlin.String
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.readResourceBytes

@ExperimentalResourceApi
internal object Res {
  /**
   * Reads the content of the resource file at the specified path and returns it as a byte array.
   *
   * Example: `val bytes = Res.readBytes("files/key.bin")`
   *
   * @param path The path of the file to read in the compose resource's directory.
   * @return The content of the file as a byte array.
   */
  public suspend fun readBytes(path: String): ByteArray = readResourceBytes(path)

  public object string {
    public val about__blurb: StringResource = get_string_about__blurb()

    public val about__orbitals__github: StringResource = get_string_about__orbitals__github()

    public val about__orbitals__github_url: StringResource =
        get_string_about__orbitals__github_url()

    public val about__orbitals__webapp: StringResource = get_string_about__orbitals__webapp()

    public val about__orbitals__webapp_url: StringResource =
        get_string_about__orbitals__webapp_url()

    public val settings: StringResource = get_string_settings()

    public val settings__color__background: StringResource =
        get_string_settings__color__background()

    public val settings__color__enum_objectcolors__any: StringResource =
        get_string_settings__color__enum_objectcolors__any()

    public val settings__color__enum_objectcolors__blue: StringResource =
        get_string_settings__color__enum_objectcolors__blue()

    public val settings__color__enum_objectcolors__green: StringResource =
        get_string_settings__color__enum_objectcolors__green()

    public val settings__color__enum_objectcolors__grey: StringResource =
        get_string_settings__color__enum_objectcolors__grey()

    public val settings__color__enum_objectcolors__orange: StringResource =
        get_string_settings__color__enum_objectcolors__orange()

    public val settings__color__enum_objectcolors__pink: StringResource =
        get_string_settings__color__enum_objectcolors__pink()

    public val settings__color__enum_objectcolors__purple: StringResource =
        get_string_settings__color__enum_objectcolors__purple()

    public val settings__color__enum_objectcolors__red: StringResource =
        get_string_settings__color__enum_objectcolors__red()

    public val settings__color__enum_objectcolors__yellow: StringResource =
        get_string_settings__color__enum_objectcolors__yellow()

    public val settings__color__objects: StringResource = get_string_settings__color__objects()

    public val settings__color__opacity: StringResource = get_string_settings__color__opacity()

    public val settings__group_title__color: StringResource =
        get_string_settings__group_title__color()

    public val settings__group_title__physics: StringResource =
        get_string_settings__group_title__physics()

    public val settings__group_title__visual: StringResource =
        get_string_settings__group_title__visual()

    public val settings__physics__auto_add: StringResource =
        get_string_settings__physics__auto_add()

    public val settings__physics__auto_add__help: StringResource =
        get_string_settings__physics__auto_add__help()

    public val settings__physics__collision_style: StringResource =
        get_string_settings__physics__collision_style()

    public val settings__physics__enum_collisionstyle__bouncy: StringResource =
        get_string_settings__physics__enum_collisionstyle__bouncy()

    public val settings__physics__enum_collisionstyle__bouncy__help: StringResource =
        get_string_settings__physics__enum_collisionstyle__bouncy__help()

    public val settings__physics__enum_collisionstyle__explode: StringResource =
        get_string_settings__physics__enum_collisionstyle__explode()

    public val settings__physics__enum_collisionstyle__explode__help: StringResource =
        get_string_settings__physics__enum_collisionstyle__explode__help()

    public val settings__physics__enum_collisionstyle__merge: StringResource =
        get_string_settings__physics__enum_collisionstyle__merge()

    public val settings__physics__enum_collisionstyle__merge__help: StringResource =
        get_string_settings__physics__enum_collisionstyle__merge__help()

    public val settings__physics__enum_collisionstyle__none: StringResource =
        get_string_settings__physics__enum_collisionstyle__none()

    public val settings__physics__enum_collisionstyle__none__help: StringResource =
        get_string_settings__physics__enum_collisionstyle__none__help()

    public val settings__physics__enum_collisionstyle__sticky: StringResource =
        get_string_settings__physics__enum_collisionstyle__sticky()

    public val settings__physics__enum_collisionstyle__sticky__help: StringResource =
        get_string_settings__physics__enum_collisionstyle__sticky__help()

    public val settings__physics__enum_systemgenerator__asteroids: StringResource =
        get_string_settings__physics__enum_systemgenerator__asteroids()

    public val settings__physics__enum_systemgenerator__asteroids__help: StringResource =
        get_string_settings__physics__enum_systemgenerator__asteroids__help()

    public val settings__physics__enum_systemgenerator__gauntlet: StringResource =
        get_string_settings__physics__enum_systemgenerator__gauntlet()

    public val settings__physics__enum_systemgenerator__gauntlet__help: StringResource =
        get_string_settings__physics__enum_systemgenerator__gauntlet__help()

    public val settings__physics__enum_systemgenerator__greatattractor: StringResource =
        get_string_settings__physics__enum_systemgenerator__greatattractor()

    public val settings__physics__enum_systemgenerator__greatattractor__help: StringResource =
        get_string_settings__physics__enum_systemgenerator__greatattractor__help()

    public val settings__physics__enum_systemgenerator__randomized: StringResource =
        get_string_settings__physics__enum_systemgenerator__randomized()

    public val settings__physics__enum_systemgenerator__randomized__help: StringResource =
        get_string_settings__physics__enum_systemgenerator__randomized__help()

    public val settings__physics__enum_systemgenerator__starsystem: StringResource =
        get_string_settings__physics__enum_systemgenerator__starsystem()

    public val settings__physics__enum_systemgenerator__starsystem__help: StringResource =
        get_string_settings__physics__enum_systemgenerator__starsystem__help()

    public val settings__physics__gravity: StringResource = get_string_settings__physics__gravity()

    public val settings__physics__maximum_population: StringResource =
        get_string_settings__physics__maximum_population()

    public val settings__physics__min_fixedbody_age: StringResource =
        get_string_settings__physics__min_fixedbody_age()

    public val settings__physics__min_fixedbody_age__help: StringResource =
        get_string_settings__physics__min_fixedbody_age__help()

    public val settings__physics__object_density: StringResource =
        get_string_settings__physics__object_density()

    public val settings__physics__object_density__help: StringResource =
        get_string_settings__physics__object_density__help()

    public val settings__physics__system_generators: StringResource =
        get_string_settings__physics__system_generators()

    public val settings__ui__close_ui: StringResource = get_string_settings__ui__close_ui()

    public val settings__ui__disable_ui: StringResource = get_string_settings__ui__disable_ui()

    public val settings__visual__draw_novae: StringResource =
        get_string_settings__visual__draw_novae()

    public val settings__visual__drawstyle: StringResource =
        get_string_settings__visual__drawstyle()

    public val settings__visual__enum_drawstyle__solid: StringResource =
        get_string_settings__visual__enum_drawstyle__solid()

    public val settings__visual__enum_drawstyle__wireframe: StringResource =
        get_string_settings__visual__enum_drawstyle__wireframe()

    public val settings__visual__enum_renderlayer__acceleration: StringResource =
        get_string_settings__visual__enum_renderlayer__acceleration()

    public val settings__visual__enum_renderlayer__default: StringResource =
        get_string_settings__visual__enum_renderlayer__default()

    public val settings__visual__enum_renderlayer__field: StringResource =
        get_string_settings__visual__enum_renderlayer__field()

    public val settings__visual__enum_renderlayer__trails: StringResource =
        get_string_settings__visual__enum_renderlayer__trails()

    public val settings__visual__render_layers: StringResource =
        get_string_settings__visual__render_layers()

    public val settings__visual__render_layers__trails_history_length: StringResource =
        get_string_settings__visual__render_layers__trails_history_length()

    public val settings__visual__stroke_width: StringResource =
        get_string_settings__visual__stroke_width()
  }
}

private fun get_string_about__blurb(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:about__blurb", "about__blurb",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_about__orbitals__github(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:about__orbitals__github", "about__orbitals__github",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_about__orbitals__github_url(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:about__orbitals__github_url", "about__orbitals__github_url",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_about__orbitals__webapp(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:about__orbitals__webapp", "about__orbitals__webapp",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_about__orbitals__webapp_url(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:about__orbitals__webapp_url", "about__orbitals__webapp_url",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:settings", "settings",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__background(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__background", "settings__color__background",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    org.jetbrains.compose.resources.RegionQualifier("GB"), ), "values-en-rGB/strings.xml"),
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__any(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__any", "settings__color__enum_objectcolors__any",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__blue(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__blue", "settings__color__enum_objectcolors__blue",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__green(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__green", "settings__color__enum_objectcolors__green",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__grey(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__grey", "settings__color__enum_objectcolors__grey",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__orange(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__orange", "settings__color__enum_objectcolors__orange",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__pink(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__pink", "settings__color__enum_objectcolors__pink",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__purple(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__purple", "settings__color__enum_objectcolors__purple",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__red(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__red", "settings__color__enum_objectcolors__red",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__enum_objectcolors__yellow(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__enum_objectcolors__yellow", "settings__color__enum_objectcolors__yellow",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__objects(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__objects", "settings__color__objects",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    org.jetbrains.compose.resources.RegionQualifier("GB"), ), "values-en-rGB/strings.xml"),
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__color__opacity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__color__opacity", "settings__color__opacity",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__group_title__color(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__group_title__color", "settings__group_title__color",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    org.jetbrains.compose.resources.RegionQualifier("GB"), ), "values-en-rGB/strings.xml"),
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__group_title__physics(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__group_title__physics", "settings__group_title__physics",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__group_title__visual(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__group_title__visual", "settings__group_title__visual",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__auto_add(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__auto_add", "settings__physics__auto_add",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__auto_add__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__auto_add__help", "settings__physics__auto_add__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__collision_style(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__collision_style", "settings__physics__collision_style",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__bouncy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__bouncy",
    "settings__physics__enum_collisionstyle__bouncy",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__bouncy__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__bouncy__help",
    "settings__physics__enum_collisionstyle__bouncy__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__explode(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__explode",
    "settings__physics__enum_collisionstyle__explode",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__explode__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__explode__help",
    "settings__physics__enum_collisionstyle__explode__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__merge(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__merge",
    "settings__physics__enum_collisionstyle__merge",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__merge__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__merge__help",
    "settings__physics__enum_collisionstyle__merge__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__none(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__none",
    "settings__physics__enum_collisionstyle__none",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__none__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__none__help",
    "settings__physics__enum_collisionstyle__none__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__sticky(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__sticky",
    "settings__physics__enum_collisionstyle__sticky",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_collisionstyle__sticky__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_collisionstyle__sticky__help",
    "settings__physics__enum_collisionstyle__sticky__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__asteroids(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__asteroids",
    "settings__physics__enum_systemgenerator__asteroids",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__asteroids__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__asteroids__help",
    "settings__physics__enum_systemgenerator__asteroids__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__gauntlet(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__gauntlet",
    "settings__physics__enum_systemgenerator__gauntlet",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__gauntlet__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__gauntlet__help",
    "settings__physics__enum_systemgenerator__gauntlet__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__greatattractor(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__greatattractor",
    "settings__physics__enum_systemgenerator__greatattractor",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__greatattractor__help():
    StringResource = org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__greatattractor__help",
    "settings__physics__enum_systemgenerator__greatattractor__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__randomized(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__randomized",
    "settings__physics__enum_systemgenerator__randomized",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__randomized__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__randomized__help",
    "settings__physics__enum_systemgenerator__randomized__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__starsystem(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__starsystem",
    "settings__physics__enum_systemgenerator__starsystem",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__enum_systemgenerator__starsystem__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__enum_systemgenerator__starsystem__help",
    "settings__physics__enum_systemgenerator__starsystem__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__gravity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__gravity", "settings__physics__gravity",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__maximum_population(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__maximum_population", "settings__physics__maximum_population",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__min_fixedbody_age(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__min_fixedbody_age", "settings__physics__min_fixedbody_age",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__min_fixedbody_age__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__min_fixedbody_age__help", "settings__physics__min_fixedbody_age__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__object_density(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__object_density", "settings__physics__object_density",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__object_density__help(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__object_density__help", "settings__physics__object_density__help",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__physics__system_generators(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__physics__system_generators", "settings__physics__system_generators",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__ui__close_ui(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__ui__close_ui", "settings__ui__close_ui",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__ui__disable_ui(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__ui__disable_ui", "settings__ui__disable_ui",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__draw_novae(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__draw_novae", "settings__visual__draw_novae",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__drawstyle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__drawstyle", "settings__visual__drawstyle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_drawstyle__solid(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_drawstyle__solid", "settings__visual__enum_drawstyle__solid",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_drawstyle__wireframe(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_drawstyle__wireframe",
    "settings__visual__enum_drawstyle__wireframe",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_renderlayer__acceleration(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_renderlayer__acceleration",
    "settings__visual__enum_renderlayer__acceleration",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_renderlayer__default(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_renderlayer__default",
    "settings__visual__enum_renderlayer__default",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_renderlayer__field(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_renderlayer__field", "settings__visual__enum_renderlayer__field",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__enum_renderlayer__trails(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__enum_renderlayer__trails", "settings__visual__enum_renderlayer__trails",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__render_layers(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__render_layers", "settings__visual__render_layers",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__render_layers__trails_history_length(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__render_layers__trails_history_length",
    "settings__visual__render_layers__trails_history_length",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)

private fun get_string_settings__visual__stroke_width(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:settings__visual__stroke_width", "settings__visual__stroke_width",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "values/strings.xml"),
    )
)
